customElements.define('component-category-slider', class CategorySlider extends HTMLElement {
  constructor() {
    super();
    // DOM elements
    this.prevSlideBtn = this.querySelector('.js-prev') || null;
    this.nextSlideBtn = this.querySelector('.js-next') || null;
    this.slides = this.querySelectorAll('.js-slide') || [];
    this.slider = this.querySelector('.js-slider') || null;
    // Set data from component
    this.sectionId = this.dataset.sectionId;
    this.subcategories = this.dataset.subcategories;

    // Event handlers
    if (this.prevSlideBtn) {
      this.prevSlideBtn?.addEventListener("click", () => {

        if (this.slider) {
          this.slider.scrollBy({ top: 0, left: -325, behavior: 'smooth' });
        }
        this.trackSubCategoryCarouselScroll(this.subcategories);
      });
    }

    if (this.nextSlideBtn) {
      this.nextSlideBtn?.addEventListener("click", () => {
        if (this.slider) {
          this.slider.scrollBy({ top: 0, left: 325, behavior: 'smooth' });
        }
        this.trackSubCategoryCarouselScroll(this.subcategories);
      });
    }

    if (this.slider) {
      this.slider?.addEventListener('scroll', () => {
        // Hide prev button if scrolled to beginning of slider
        if (this.slider.scrollLeft > 0) {
          if (this.prevSlideBtn) {
            this.prevSlideBtn.classList.remove('btn--disabled');
          }
        } else {
          if (this.prevSlideBtn) {
            this.prevSlideBtn.classList.add('btn--disabled');
          }
        }
        // Hide next button if scrolled to end of slider
        if (this.slider.scrollLeft < (this.slider.scrollWidth - this.slider.offsetWidth - 10)) {
          if (this.nextSlideBtn) {
            this.nextSlideBtn.classList.remove('btn--disabled');
          }
        } else {
          if (this.nextSlideBtn) {
            this.nextSlideBtn.classList.add('btn--disabled');
          }
        }
      }, { passive: true });
    }
    
    this.slides?.forEach(slide => {
      const slidePosition = slide.dataset.position;
      const slideImage = slide.dataset.slideImage2 ? slide.dataset.slideImage2 : slide.dataset.slideImage1;
      const slideTitle = slide.dataset.slideTitle;
      const slideUrl = slide.dataset.slideUrl;
      slide.addEventListener("click", () => {
        this.trackSubCategoryClick(this.subcategories, slideTitle, slidePosition, slideImage, slideUrl);
      });
    });
  }
  trackSubCategoryCarouselScroll(subcategories) {
    window.sendGTMData && window.sendGTMData({
      event: 'plp_subcategory_carousel_scroll',
      collection_type: window.theme?.collection?.title || '',
      subcategory_items: subcategories  || ''
    });
  }
  trackSubCategoryClick(subcategories, name, position, image, url) {
    window.sendGTMData && window.sendGTMData({
      event: 'plp_subcategory_carousel_click',
      collection_type: window.theme?.collection?.title || '',
      subcategory_items: subcategories || '',
      subcategory_name: name || '',
      subcategory_position: position,
      subcategory_image: image,
      subcategory_link: url
    });
  }
  renderImages() {
    this.slides?.forEach(slide => {
      const slideImage = slide.dataset.slideImage2 ? slide.dataset.slideImage2 : slide.dataset.slideImage1;
      slide.querySelector('.js-image').dataset.src = slideImage;
      slide.querySelector('.js-image').dataset.srcset = getSrcset(slideImage, '180', ['180', '360', '720'], true);
      slide.querySelector('.js-image').classList.add('lazyload');
    });
  }
});
